import Login from './Pages/Login';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Home from './Pages/Home';
import About from './Pages/About';
import Webdev from './Pages/Webdev';
import AISector from './Pages/AISector';
import Contact from './Pages/Contact';
import { useState } from 'react';
import NewsFeeds from './Pages/NewsFeeds';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Login isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        <Route path='/Home' element={<Home isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        <Route path='/About' element={<About isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        <Route path='/Website-Development-Sector' element={<Webdev isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        <Route path='/Artificial-Intelligence-Sector' element={<AISector isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        <Route path='/Contact-BlueLoop' element={<Contact isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        
        <Route path='/Newsfeeds' element={<NewsFeeds isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />} />
        </Routes>
    </Router>

  );
}

export default App;
